import { Country } from './country.aggregate';

export const countryService = {
  createCountry: (country: Country): Country => {
    const deepCountryObjectCopy = Object.assign({}, country);
    const inmutableCountryObkect = Object.freeze(deepCountryObjectCopy);
    return inmutableCountryObkect;
  }
};
